import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { SettlementCompleteDateAdjustmentContainer } from '../../containers/balance/SettlementCompleteDateAdjustmentContainer';
import { BALANCE_PAGE_NAME } from '../../constants/service/app/balanceConstants';

/**
 * 정산 완료일 변경 페이지.
 *
 * status=completed 정산아이템의 completeDate 단일 필드를 일괄 이동시키는 운영 기능.
 * 탭 2개(변경 작업 실행 / 이력·롤백)로 구성. 기준일 변경(SettlementDateAdjustment)
 * 페이지와 동일한 진입 구조이지만 도메인/필드 의미가 다르다.
 */
const SettlementCompleteDateAdjustment = (): React.JSX.Element => {
  return (
    <PageTemplate pageName={BALANCE_PAGE_NAME.BALANCE_COMPLETE_DATE_ADJUSTMENT}>
      <SettlementCompleteDateAdjustmentContainer />
    </PageTemplate>
  );
};

export default SettlementCompleteDateAdjustment;
